import { render } from "./BaseTextarea.vue?vue&type=template&id=64b9c532"
import script from "./BaseTextarea.vue?vue&type=script&lang=ts"
export * from "./BaseTextarea.vue?vue&type=script&lang=ts"
script.render = render

export default script